<template>
  <div
    class="p-1 mx-2 flex items-center justify-between mt-2 mb-0.5 rounded-full lg:hidden"
  >
    <div class="flex items-center gap-5 ml-3">
      <NuxtLink to="/">
        <LogoSquare />
      </NuxtLink>

      <Button
        variant="outline"
        size="icon"
        class="w-10 h-10"
        :disabled="!loggedIn"
        @click="toggleSidebar"
      >
        <PanelLeft />
        <span class="sr-only">Toggle Sidebar</span>
      </Button>
    </div>

    <AuthButton />
  </div>
</template>

<script lang="ts" setup>
import { PanelLeft } from "lucide-vue-next";
import AuthButton from "./AuthButton.vue";
import { useSidebar } from "../ui/sidebar";
import LogoSquare from "./LogoSquare.vue";

const { status } = useAuth();
const loggedIn = computed(() => status.value === "authenticated");

const { toggleSidebar } = useSidebar();
</script>
